export default {
  individual: 'Custom',
  fixed: 'Fixed Length',
  one_many: 'Group Rolling Calendar',
  membership: 'Session 1, Day 1',
};
